import { createAction } from 'redux-actions';
import { push } from 'react-router-redux';
import { openGlobalModal } from 'actions/modal';
import { toggleLoading } from 'actions/global';
import moment from 'moment';

import { wrapFetchAuth, wrapFetchFormData } from './endpoint';

export const toggleMode = createAction('MODE_TOGGLE', toggle => ({ toggle }));

export const getProductList = createAction('GET_PRODUCT_LIST', () => async dispatch => {
	dispatch(toggleLoading(true));
	const { status, data } = await wrapFetchAuth('api/web/user/product', {
		method: 'GET',
	});
	dispatch(toggleLoading(false));

	if (status === 200) {
		return {
			list: data,
		};
	}
	return {};
});

export const getProductInfo = createAction('GET_PRODUCT_INFO', (number, type) => async dispatch => {
	dispatch(toggleLoading(true));
	const { status, data, message } = await wrapFetchAuth(`api/web/product/${number}?type=${type}`, {
		method: 'GET',
	});
	dispatch(toggleLoading(false));

	if (status === 200) {
		if (data.archive === 1) {
			dispatch(openGlobalModal('productInfoError'));
		}
		return {
			info: {
				type: data.model.type.name,
				name: data.model.name,
				image: data.model.image,
				oldBuyDate: data.old_buy_date,
				purchase: data.purchase_date,
				shipping: data.shipping_date,
				warrantyMonth: data.model.warranty_month,
				warrantyEnd: data.warranty_end,
				dealer: data.dealer_id,
				dealerSell: data.shop_sell_date,
				archive: data.archive,
			},
		};
	} else if (status === 201) {
		dispatch(openGlobalModal('productSecondRepeat'));
		return {
			info: {
				type: data.model.type.name,
				name: data.model.name,
				image: data.model.image,
				purchase: data.purchase_date,
			},
		};
	} else if (status === 404) {
		dispatch(openGlobalModal('noProductNumber'));
		return {
			info: {
				type: '',
				name: '',
				image: '',
				gift: false,
			},
		};
	} else if (status === 400) {
		if (message === 'product has already be registered') {
			dispatch(openGlobalModal('productNewRepeat'));
		} else if (message === 'seller disagree') {
			dispatch(openGlobalModal('productSellerDisagree'));
		} else if (message === 'already requested') {
			dispatch(openGlobalModal('productSellerNotReply'));
			console.log(data.date);
			return {
				info: {
					date: data.date,
				},
			};
		} else if (message === 'type error') {
			dispatch(openGlobalModal('productInfoError'));
		}
	}

	return {
		info: {
			type: '',
			name: '',
			image: '',
		},
	};
});

export const addProduct = createAction('ADD_PRODUCT', (type, num, date, file) => async dispatch => {
	const data = new FormData();
	data.append('type', type);
	data.append('series_number', num);
	if (date !== '') {
		data.append('buy_date', date);
	}
	if (file !== undefined) {
		data.append('warranty_card', file, 'card');
	}
	dispatch(toggleLoading(true));
	const result = await wrapFetchFormData('api/web/user/product', {
		method: 'POST',
		body: data,
	});
	dispatch(toggleLoading(false));

	if (result.status === 200) {
		dispatch(openGlobalModal('productAddSuccess'));
		dispatch(getProductList());
		if (
			result.reply_gift_events.length !== 0 &&
			result.reply_gift_events.find(
				gift => moment(gift.date_to).diff(moment()) > 0 &&
					gift.status === 1 &&
					moment(gift.buy_to).diff(moment(result.buy_date, 'YYYY/MM/DD')) > 0 &&
					moment(gift.buy_from).diff(moment(result.buy_date, 'YYYY/MM/DD')) < 0,
			) &&
			result.type !== 'SECOND_HAND'
		) {
			return {
				info: {
					type: '',
					name: '',
					image: '',
				},
				addProduct: {
					event: true,
					id: result.id,
				},
			};
		}
		return {
			info: {
				type: '',
				name: '',
				image: '',
			},
			addProduct: {
				event: false,
				id: '',
			},
		};
	} else if (result.status === 400) {
		if (result.message === 'buy date error' || result.message === 'time expired') {
			dispatch(openGlobalModal('productBuyDateError'));
		} else if (result.message === 'product has already be registere') {
			dispatch(openGlobalModal('productNewRepeat'));
		} else if (result.message === 'The given data was invalid') {
			dispatch(openGlobalModal('productInfoError'));
		} else if (result.message === 'please connect customer service') {
			console.log('洽詢客服');
			dispatch(openGlobalModal('productInfoError'));
		}
	}
	return {};
});

export const addProductActivity = createAction('ADD_PRODUCT_ACTIVITY', (type, num, date, file, apply, invoice) => async dispatch => {
	const data = new FormData();
	data.append('type', type);
	data.append('series_number', num);
	if (date !== '') {
		data.append('buy_date', date);
	}
	if (file !== undefined) {
		data.append('warranty_card', file, 'card');
	}
	data.append('apply_event', apply);
	data.append('invoice_file', invoice);
	dispatch(toggleLoading(true));
	const result = await wrapFetchFormData('api/web/user/product', {
		method: 'POST',
		body: data,
	});
	dispatch(toggleLoading(false));

	if (result.status === 200) {
		dispatch(push(`/product/${result.id}/activity`));
		dispatch(getProductList());
		return {
			info: {
				type: '',
				name: '',
				image: '',
			},
		};
	} else if (result.status === 400) {
		if (result.message === 'buy date error' || result.message === 'time expired') {
			dispatch(openGlobalModal('productBuyDateError'));
		} else if (result.message === 'product has already be registere') {
			dispatch(openGlobalModal('productNewRepeat'));
		} else if (result.message === 'The given data was invalid') {
			dispatch(openGlobalModal('productInfoError'));
		} else if (result.message === 'please connect customer service') {
			console.log('洽詢客服');
			dispatch(openGlobalModal('productInfoError'));
		}
	}
	return {};
});

export const getRecommendCourse = createAction('GET_RECOMMEND_COURSE', id => async () => {
	const { status, data } = await wrapFetchAuth(`api/web/user/product/${id}/recommendCourse`, {
		method: 'GET',
	});

	if (status === 200) {
		return {
			courseList: data,
		};
	}
	return {};
});

export const getProduct = createAction('GET_PRODUCT', id => async dispatch => {
	dispatch(toggleLoading(true));
	const { status, data } = await wrapFetchAuth(`api/web/user/product/${id}`, {
		method: 'GET',
	});

	dispatch(toggleLoading(false));

	if (status === 200) {
		return {
			product: {
				id: data.id,
				type: data.type,
				number: data.product.series_number,
				typeName: data.product.model.type.name,
				typeCode: data.product.model.name,
				image: data.product.model.image,
				date: data.buy_date,
				warranty: data.warranty_card,
				name: data.product.model.name,
				warrantyEnd: data.warranty_end,
				invoice: data.invoice_file,
			},
			maintain: data.product.maintain_logs,
		};
	}
	return {};
});

export const defaultProductInfo = createAction('DEFAULT_PRODUCT_INFO', () => ({
	product: {
		id: '',
		type: '',
		number: '',
		name: '',
		code: '',
		image: '',
		date: '',
		warranty: '',
		warrantyEnd: '',
		gift: false,
	},
	maintain: [],
}));

export const productStolen = createAction('PRODUCT_STOLEN', id => async dispatch => {
	const { status } = await wrapFetchAuth(`api/web/user/product/${id}`, {
		method: 'PUT',
		body: JSON.stringify({ status: 'STOLEN' }),
	});

	console.log(id);

	if (status === 200) {
		console.log('申報失竊成功');
		dispatch(getProductList());
		dispatch(openGlobalModal('productLoseComplete'));
	}
	return {};
});

export const transferProduct = createAction('TRANSFER_PRODUCT', (id, _status) => async dispatch => {
	const { status, data, message } = await wrapFetchAuth(`api/web/user/productTransfer/${id}`, {
		method: 'PUT',
		body: JSON.stringify({ status: _status }),
	});

	if (status === 200) {
		console.log('轉讓成功');
		dispatch(push('/product'));
		if (_status === 'AGREE') {
			dispatch(openGlobalModal('productTransferAgree'));
		} else if (_status === 'DISAGREE') {
			dispatch(openGlobalModal('productTransferDisagree'));
		}
		return {
			transferName: data.name,
		};
	} else if (status === 400) {
		if (message === 'product has been sold') {
			dispatch(push('/product'));
			if (_status === 'AGREE') {
				dispatch(openGlobalModal('productTransferBeenSold'));
			} else if (_status === 'DISAGREE') {
				dispatch(openGlobalModal('productTransferCanNotChange'));
			}
			return {
				transfered: {
					name: data.name,
					number: data.series_number,
				},
			};
		}
	}
	return {};
});

export const productActivity = createAction('PRODUCT_ACTIVITY', (id, apply, invoice) => async dispatch => {
	const data = new FormData();
	data.append('apply_event', apply);
	data.append('invoice_file', invoice);
	data.append('_method', 'PUT');
	dispatch(toggleLoading(true));
	const { status } = await wrapFetchFormData(`api/web/user/product/${id}`, {
		method: 'POST',
		body: data,
	});
	dispatch(toggleLoading(false));

	console.log(status);
	if (status === 200 || status === 'NORMAL') {
		dispatch(push(`/product/${id}/activity`));
	}
});



// WEBPACK FOOTER //
// ./src/actions/product.js